import { contrastRatio } from "@kundeninfo/ui";

/**
 * Textvarianten je Farbschema für die drei bekannten Konzernunternehmen — Werte gemessen
 * und dokumentiert in assets/logos/README.md. Die rohe Markenfarbe reicht dort als Textfarbe
 * nicht durchgängig: Bitshifters (2,8:1) und Meine-Energie (2,5:1) unterschreiten gegen Weiß
 * die geforderten 4,5:1 nach WCAG AA, proassisto (16,2:1) trägt hell, aber nicht dunkel.
 */
const BEKANNTE_MARKEN: Record<string, { hell: string; dunkel: string }> = {
  "#EE7B1C": { hell: "#B75A0E", dunkel: "#EE7B1C" }, // Bitshifters
  "#7AB41E": { hell: "#588216", dunkel: "#7AB41E" }, // Meine-Energie
  "#161C49": { hell: "#161C49", dunkel: "#7984D7" }, // proassisto
};

/**
 * Textfarbe zu einer Markenfarbe, je Farbschema. Für die drei bekannten Unternehmen gelten
 * die gemessenen Werte oben; für weitere Marken (Bestand wächst über die Zeit) prüft dieser
 * Fallback testweise, ob die rohe Farbe selbst genug Kontrast gegen die jeweilige Chip-Fläche
 * erreicht (4,5:1), und weicht sonst auf den normalen Fließtext des Farbschemas aus.
 */
export function markenTextfarben(colorHex: string): { hell: string; dunkel: string } {
  const bekannt = BEKANNTE_MARKEN[colorHex.toUpperCase()];
  if (bekannt !== undefined) return bekannt;
  return {
    hell: contrastRatio(colorHex, "#ffffff") >= 4.5 ? colorHex : "#1b1b19",
    dunkel: contrastRatio(colorHex, "#1d2023") >= 4.5 ? colorHex : "#e9ebed",
  };
}
